export const sortCatalogs = (catalogs = []) =>
  [...catalogs].sort(
    (a, b) => (a.displayOrder || 999) - (b.displayOrder || 999),
  );

export const sortCategories = (categories = []) =>
  [...categories].sort(
    (a, b) => (a.displayOrder || 999) - (b.displayOrder || 999),
  );

export const sortItems = (items = []) =>
  [...items].sort(
    (a, b) =>
      (a.displayOrder || 999) - (b.displayOrder || 999) ||
      (a.name || "").localeCompare(b.name || ""),
  );
